/* eslint-disable */
module.exports = {
  name: "cc",
  description: "Credit Card / Debit",
  image: "https://ik.imagekit.io/powerbiz/utils/cc.svg",
  instructions: null
};
